import React from 'react'

import { branch } from 'baobab-react/higher-order'
import { bool, func, string } from 'prop-types'
import storage from 'utils/storage'
import getNewIcon from 'utils/getNewIcon'

import Typography from 'components/atoms/Typography'

const MenuItem = ({ url, onClick, label, iconName, isActive, checkTerms, currentUser }) => {
  const color = isActive ? '#00C2C9' : '#6B8FBC'
  const handleClick = () => {
    if (checkTerms) {
      if (currentUser && !currentUser.agreed_to_campus_terms) {
        storage.set('vpMetaNotice', true)
      } else if (!currentUser) {
        window.location.href = `/signin?successUrl=${encodeURIComponent(window.location.pathname)}`
      } else {
        onClick && onClick()
        window.location.href = url || '#'
      }
    } else {
      onClick && onClick()
      window.location.href = url || '#'
    }
  }
  return (
    <>
      <div
        className="navbar-menu-item"
        onClick={handleClick}
      >
        {getNewIcon(iconName, color)}
        <Typography variant="note" fontWeight="bold" component="span">
          {label}
        </Typography>
      </div>
      <style jsx global>
        {`
          .navbar-menu-item {
            display: flex;
            align-items: center;
            justify-content: center;
            flex-direction: column;
            cursor: pointer;
            margin: 8px;
            svg {
              margin-bottom: 4px;
            }
            span {
              color: #6B8FBC;
            }
            &:focus, &:hover  {
              text-decoration: none;
            }
          }
        `}
      </style>
    </>
  )
}

MenuItem.propTypes = {
  url: string,
  onClick: func,
  label: string,
  iconName: string,
  isActive: bool,
  checkTerms: bool,
}

MenuItem.defaultProps = {
  isActive: false,
  checkTerms: false,
}

export { MenuItem }
export default branch({
  currentUser: ['serverProps', 'currentUser'],
}, MenuItem)
